import React, { Component } from 'react'
import { FormGroup, FormControl } from 'react-bootstrap'
import Form from '../../../../features/commons/ContactForm/ContactForm.container'
import { translate } from "react-translate"
import Scroll from 'react-scroll';

@translate("Propiedad")
export default class FormContact extends Component {
  render () {

  	const { property, t} = this.props

    var Element = Scroll.Element;

    return (
      <Element name="ContactForm">
      	<div className="form-contact">
          <h2>{t("Contactanos_text")} <span> {t('Contactanos_Strong')}</span></h2>
          <Form textareaDefault={true} property={property} />
        </div>
      </Element>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/Detail/form.js